import {merge} from '@shared/helpers/object'

import getStorage from '@web/helpers/storage'

import {InitDeliveryManagerPayload} from '../interfaces'

/**
 * 외부에 노출하지 않을 스토리지 관리 객체
 * 새로고침 시 스토어 데이터가 날아가므로, 새로고침 시에도 아래 사용처에서 데이터를 유지하기 위해 정의.
 * - 배송지변경화면 폼데이터, 주소검색화면 검색키워드 복원
 * - 모바일 배송지변경스크린 초기화를 위한 타입 복원
 * */
const deliveryManagerStorage = getStorage<InitDeliveryManagerPayload>('initDeliveryManagerPayload')

/** 새로고침 케이스를 지원하기 위한 아래 함수들 외에는 되도록 확장을 지양하고, 스토어를 사용하는것이 권장됨. */

/** originalValue에 스토리지 저장 데이터를 덮어씌워서 반환 */
export const mergeStorageDataToOriginalPayload = (originalValue: InitDeliveryManagerPayload) => {
    const storedData = deliveryManagerStorage.get({})

    return merge(originalValue, storedData)
}

// 다음 새로고침 케이스에 대응할 수 있도록 스토리지에 현재까지 만든 데이터 저장.
export const saveDeliveryManagerSessionStorage = (payload: InitDeliveryManagerPayload) => {
    deliveryManagerStorage.set(payload)
}

// 스토리지 제거
export const clearStorage = () => {
    deliveryManagerStorage.clear()
}

// 새고로침 시 초기화액션에 타입을 전달하기 위해 스토리지에 저장된 오픈타입 반환
export const getStorageDeliveryManagerType = () => {
    return deliveryManagerStorage.get({}).type
}
